import * as statuses from 'constants/statuses';

const initialState = {
  status: statuses.IDLE,
  memberSince: null,
  numberOfProductBoughtSinceLastUnlock: null,
  numberOfPendingSelectionProducts: null,
  currentSelectedFreeProduct: {
    slug: null,
    // expired_at: null,
  },
  freeProductCatalog: [],
};

export default initialState;
